import { Component } from "react"

/* Modal */
import Modal from "react-modal"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* DatePicker */
import DatePicker, { registerLocale } from "react-datepicker"
import ru from "date-fns/locale/ru"
import Swal from "sweetalert2"
import { utils } from "../../helpers"

/* DatePicker Settings */
registerLocale("ru", ru)



/* Widget Player Filter */
class Filter extends Component {

    constructor() {
        super()

        this.state = {
            selected: "today",
            visible: false,
            start: null,
            end: null,
            operators: [],
        }
    }

    /* Get Dates */
    _getDates = () => [
        { key: "3hours", text: t("player.last3h") },
        { key: "6hours", text: t("player.last6h") },
        { key: "12hours", text: t("player.last12h") },
        { key: "today", text: t("player.today") },
        { key: "yesterday", text: t("player.yesterday") },
        { key: "7days", text: t("player.last7days") },
        { key: "14days", text: t("player.last14days") },
        { key: "30days", text: t("player.last30days") },
        { key: "month", text: t("player.thisMonth") },
        { key: "prevmonth", text: t("player.prevMonth") },
        { key: "all", text: t("player.allTime") },
    ]

    /* Open Action */
    open = ({ start, end, selected, operators }) => {
        this.setState({ visible: true, start, end, selected, operators })
    }

    /* Select Action */
    select = (selected) => {

        /* 3 Hours */
        if (selected === "3hours") {
            const start = new Date()
            const end = new Date()
            start.setHours(start.getHours() - 3)
            this.setState({ start, end, selected })
        }


        /* 6 Hours */
        if (selected === "6hours") {
            const start = new Date()
            const end = new Date()
            start.setHours(start.getHours() - 6)
            this.setState({ start, end, selected })
        }

        /* 12 Hours */
        if (selected === "12hours") {
            const start = new Date()
            const end = new Date()
            start.setHours(start.getHours() - 12)
            this.setState({ start, end, selected })
        }

        /* Today */
        if (selected === "today") {
            const start = new Date()
            const end = new Date()
            start.setHours(0, 0, 0)
            end.setHours(23, 59, 59)
            this.setState({ start, end, selected })
        }

        /* Yesterday */
        if (selected === "yesterday") {
            const start = new Date()
            const end = new Date()
            start.setDate(start.getDate() - 1)
            end.setDate(end.getDate() - 1)
            start.setHours(0, 0, 0)
            end.setHours(23, 59, 59)
            this.setState({ start, end, selected })
        }

        /* 7 days */
        if (selected === "7days") {
            const start = new Date()
            const end = new Date()
            start.setDate(end.getDate() - 6)
            start.setHours(0, 0, 0)
            end.setHours(23, 59, 59)
            this.setState({ start, end, selected })
        }

        /* 14 days */
        if (selected === "14days") {
            const start = new Date()
            const end = new Date()
            start.setDate(end.getDate() - 13)
            start.setHours(0, 0, 0)
            end.setHours(23, 59, 59)
            this.setState({ start, end, selected })
        }


        /* 30 days */
        if (selected === "30days") {
            const start = new Date()
            const end = new Date()
            start.setDate(end.getDate() - 29)
            start.setHours(0, 0, 0)
            end.setHours(23, 59, 59)
            this.setState({ start, end, selected })
        }

        /* This month */
        if (selected === "month") {

            const now = new Date()
            const year = now.getFullYear()
            const month = now.getMonth()

            const start = new Date(year, month, 1, 0, 0, 0)
            const end = new Date(year, month + 1, 0, 23, 59, 59)

            this.setState({ start, end, selected })
        }

        /* Prev month */
        if (selected === "prevmonth") {

            const now = new Date()
            const year = now.getFullYear()
            const month = now.getMonth()

            const start = new Date(year, month - 1, 1, 0, 0, 0)
            const end = new Date(year, month, 0, 23, 59, 59)

            this.setState({ start, end, selected })
        }

        /* All Period */
        if (selected === "all") {
            this.setState({ start: null, end: null, selected })
        }

    }

    /* Toggle Operator */
    toggleOperator = (operator) => {

        /* Fields */
        const { operators } = this.state

        /* Get Index */
        const index = operators.findIndex((e) => parseInt(e.id) === parseInt(operator.id))

        /* Check Index */
        if (index > -1) {

            if (operators.length === 1) {
                return
            }

            operators.splice(index, 1)
        }
        else {
            operators.push(operator)
        }

        this.setState({ operators })
    }

    /* Check Operator */
    checkOperator = (operator) => {

        /* Fields */
        const { operators } = this.state

        /* Get Index */
        const index = operators.findIndex((e) => parseInt(e.id) === parseInt(operator.id))

        /* Check Index */
        if (index > -1) {
            return true
        }

        return false
    }

    /* Apply Action */
    apply = () => {

        /* Fields */
        const { selected, start, end, operators } = this.state
        const { apply } = this.props

        /* Check All Period */
        if (selected !== "all") {
            if (!start || !end) {
                Swal.fire(utils.notification(t("filter.selectDates"), "error", 2000))
                return
            }
        }

        /* Set Apply */
        apply({ selected, start, end, operators })

        /* Close Modal */
        this.setState({ visible: false })
    }


    render = () => {

        /* Fields */
        const { visible, selected, start, end } = this.state
        const { operators } = this.props

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.setState({ visible: false })}
                className="player--filter-modal"
                overlayClassName="player--filter-overlay"
                closeTimeoutMS={200}
            >

                {/* Draw Header */}
                <div className="player--filter-header">
                    <h2>{t("player.filter")}</h2>
                    <div onClick={() => this.setState({ visible: false })} className="player--filter-close">
                        <img src="/images/close.png" alt="Close" />
                    </div>
                </div>

                <div className="player--filter-body">

                    {/* Draw Filters */}
                    <div className="player--filter-dates">
                        {this._getDates().map((item, index) =>
                            <div onClick={() => this.select(item.key)} key={`${index}`} className={`player--filter-date ${selected === item.key ? "active" : "default"}`}>
                                {item.text}
                            </div>
                        )}
                    </div>

                    {/* Draw Inputs */}
                    <div className="player--filter-inputs">

                        <DatePicker
                            selected={start}
                            onChange={(date) => this.setState({ start: date, selected: "period" })}
                            selectsStart
                            startDate={start}
                            endDate={end}
                            maxDate={end}
                            dateFormat="dd-MM-yyyy HH:mm"
                            locale="ru"
                            showTimeSelect
                            placeholderText="00-00-0000 00:00"
                        />

                        <DatePicker
                            selected={end}
                            onChange={(date) => this.setState({ end: date, selected: "period" })}
                            selectsEnd
                            startDate={start}
                            endDate={end}
                            minDate={start}
                            dateFormat="dd-MM-yyyy HH:mm"
                            locale="ru"
                            showTimeSelect
                            placeholderText="00-00-0000 00:00"
                        />

                    </div>

                    {/* Draw Inputs */}
                    <div className="player--filter-operators">
                        <div className="player--filter-operators-title">{t("player.operators")}</div>
                        <div className="player--filter-operators-text">{t("player.selectOperator")}</div>
                        <div className="player--filter-operators-container">
                            {operators.map((item, index) =>
                                <div onClick={() => this.toggleOperator(item)} className={`player--filter-operator ${this.checkOperator(item) ? "active" : "disabled"}`} key={`${index}`}>{item.name}</div>
                            )}
                        </div>
                    </div>

                </div>

                {/* Draw Bottom */}
                <div className="player--filter-bottom">
                    <div onClick={() => this.setState({ visible: false })} className="player--filter-button">{t("filter.cancel")}</div>
                    <div onClick={() => this.apply()} className="player--filter-button apply">{t("filter.apply")}</div>
                </div>

            </Modal>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        operators: state.operators,
        language: state.language,
    }
}

export default connect(mapStateToProps, null, null, { forwardRef: true })(Filter)

